<div class="info-message" *ngIf="control?.info && control?.touched">
    <span>{{control.info}}</span>
</div>
<div class="validation-message" *ngIf="errorMessage">
    <span [innerHTML]="errorMessage"></span>
</div>